import { consume } from "@lit/context";
import type { DocumentDTO } from "@pentacode/core";
import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { type EnabledFeatures, enabledFeatures } from "../../contexts/features-context";
import { documentOriginMeta } from "./document-origin";

@customElement("ptc-document-origin-pill")
export class DocumentOriginPill extends LitElement {
    @property({ attribute: false })
    document: Pick<DocumentDTO, "origin">;

    @consume({ context: enabledFeatures, subscribe: true })
    private _enabledFeatures?: EnabledFeatures;

    createRenderRoot() {
        return this;
    }

    render() {
        const meta = documentOriginMeta[this.document.origin];
        if (!this._enabledFeatures?.documentOriginFilter || !meta) {
            return null;
        }
        return html` <div class="pill">${meta.label}</div> `;
    }
}
